import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/car-depreciation-calculator',
  component: () => import('../../routes/CarDepreciation.svelte'),
  card: {
    id: 'car-depreciation',
    title: 'Car Depreciation Calculator',
    description: 'Calculate how your car loses value over time using straight-line, declining balance, or double declining balance methods.',
    icon: 'trending_down',
    iconBgClass: 'bg-slate-50',
    iconTextClass: 'text-slate-600',
    href: '/car-depreciation-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Car Depreciation Calculator – Estimate Vehicle Value Loss',
    description:
      'Free car depreciation calculator. See how your vehicle loses value over time using straight-line, 150% declining balance, or double declining balance methods. Includes year-by-year schedule.',
  },
};

export default meta;
